import Paragraph from "@tiptap/extension-paragraph"

export const ParagraphWithDataTitle = Paragraph.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      dataTitle: {
        default: null,
        parseHTML: element => element.getAttribute("data-title"),
        renderHTML: attributes => {
          if (!attributes.dataTitle) return {}
          return {
            "data-title": attributes.dataTitle
          }
        }
      }
    }
  }
})
